// extracted by mini-css-extract-plugin
export default {"wrapper":"_d00f0dff","additionalSpacing":"_746c3214"};